import {Component} from '@angular/core';
import {ActionSheetController, Events, ModalController, NavController, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {ServicesPage} from "../services/services";
import {interval} from "rxjs/observable/interval";
import {takeWhile} from "rxjs/operators";
import {LobbyScreensaverPage} from "../lobby-screensaver/lobby-screensaver";
import moment from "moment";
import {CancelledBookingsPage} from "../cancelled-bookings/cancelled-bookings";
import {AdvancedBookingsTimePage} from "../advanced-bookings-time/advanced-bookings-time";
import {AdvancedBookingsPage} from "../advanced-bookings/advanced-bookings";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";
import {RegisterGuestServiceProvider} from "../../providers/register-guest-service/register-guest-service";
import {AppServiceProvider} from "../../providers/app-service/app-service";
import {StaffServiceProvider} from "../../providers/staff-service/staff-service";
import { BarberBookingNewPage } from '../barber-booking-new/barber-booking-new';

/**
 * Generated class for the LobbyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-lobby',
    templateUrl: 'lobby.html',
})
export class LobbyPage {

    teamId: string;
    errors: {};
    loading: boolean;
    shop: any;
    source: any;
    subscribe: any;
    displayScreenSaver: boolean;
    screenSaverTimer: number;

    constructor(
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public navParams: NavParams,
        public events: Events,
        public modalCtrl: ModalController,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider,
        private actionSheetCtrl: ActionSheetController,
        private tabsProvider: TabsServiceProvider,
        private registerGuestService: RegisterGuestServiceProvider,
        private appService: AppServiceProvider,
        public staffService: StaffServiceProvider
    ) {
        this.teamId = localStorage.getItem('currentTeamId');
    }

    ngOnInit() {
        this.resetTimer();
        this.refreshShop();
    }

    ionViewDidEnter() {
        this.loading = true;
        this.getShop().then((shop) => {
            return this.getHolidays(shop).then((shopWithHolidays) => {
                this.shop = shopWithHolidays;
            });
        });
      this.screenSaver();
    }

    ionViewDidLeave()
    {
      this.subscribe.unsubscribe();
    }

    getAppData(){
      return this.appService.dataForAppByPackageName();
    }

    getShop() {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.teamId}`)
                .subscribe((shop: any) => {
                    this.getBookings().then((bookings: any) => {
                        shop.users.forEach((user, index) => {
                            shop.users[index].bookings = bookings[user.id]
                        });

                        this.http.get(`/teams/${shop.id}/queue`)
                            .subscribe((response: any) => {
                                shop.queue = response;
                                return resolve(shop);
                            });
                    });
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject(error);
                }, () => {
                });
        });
    }

    getBookings() {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.teamId}/current-standard-bookings`)
                .subscribe((bookings: any) => {
                    return resolve(bookings);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject(error);
                }, () => {

                });
        });
    }

    getHolidays(shop) {
        return new Promise((resolve, reject) => {
            this.loading = true;
            this.http.get(`/teams/${shop.id}/staff-holiday`)
                .subscribe(holidays => {
                    shop.users.forEach((user, index) => {
                        shop.users[index].holidays = [];
                        if (holidays[user.id]) {
                            shop.users[index].holidays = holidays[user.id];
                        }
                    });
                    resolve(shop);

                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    reject(error)
                }, () => {
                    this.loading = false;
                })
        });
    }

    canBookInAdvance() {
        if (this.shop.allow_advanced_booking && this.shop.settings.num_days_bookings_can_be_made_in_advance > 0) return true;
        return false;
    }

    openAdvancedBookingPage() {
        this.registerGuestService.register().then(guestUser=>{
            // this.navCtrl.push(AdvancedBookingsPage, {
            //   shop: this.shop,
            //   byStaff: true,
            //   fromLobby: true,
            //   guestUser: guestUser
            // });
            this.navCtrl.push(BarberBookingNewPage, {
                shop: this.shop,
                byStaff: true,
                fromLobby: true,
                guestUser: guestUser,
                isAdvanceBooking: true
            });
        }).catch(_=>{

        });
    }

    barberHasAdvancedBookingHoursForToday(barber) {
        if (barber.advanced_booking_hours) {
            let dayOfWeek = moment(new Date()).format('dddd').toLowerCase();
            if (barber.advanced_booking_hours[dayOfWeek]) {
                return true;
            }
        }
        return false;
    }

    selectServiceType(barber) {

        // Do nothing if the queue is full
        if (this.isBarberAvailableAndQueueFull(barber)) return;
        if (this.isBarberQueueFull(barber)) return;


        this.registerGuestService.register().then(guestUser=>{
            this.navCtrl.push(BarberBookingNewPage, {
                shop: this.shop,
                byStaff: true,
                fromLobby: true,
                guestUser: guestUser,
                isAdvanceBooking: true,
                barber : barber
            });
        });
        // let actionSheet;

        // let actionSheetButtons: any = [
        //     {
        //         text: 'Cancel',
        //         role: 'cancel',
        //         handler: () => {
        //         }
        //     }
        // ];

        // let advancedBookingButton = {
        //     text: 'Advanced Booking',
        //     handler: () => {

        //       actionSheet.dismiss().then(_=>{
        //         let todaysDate = moment(new Date()).format('DD/MM/YYYY');
        //         this.registerGuestService.register().then(guestUser=>{
        //           this.navCtrl.push(AdvancedBookingsTimePage, {
        //             date: todaysDate,
        //             shop: this.shop,
        //             barber: barber,
        //             byStaff: true,
        //             guestUser: guestUser,
        //             fromLobby: true
        //           });
        //         }).catch(_=>{

        //         });
        //       });
        //       return false;

        //     }
        // };

        // if (this.barberHasAdvancedBookingHoursForToday(barber)) {
        //     actionSheetButtons.unshift(advancedBookingButton);
        // }

        // let standardBookingButton = {
        //     text: 'Join the Queue',
        //     handler: () => {
        //       actionSheet.dismiss().then(_=>{
        //         this.registerGuestService.register().then(guestUser=>{
        //             this.openServices(barber, guestUser);
        //         }).catch(_=>{

        //         });
        //       });
        //       return false;
        //     }
        // };

        // if (!this.isBarberUnavailable(barber)) {
        //     actionSheetButtons.unshift(standardBookingButton);
        // }

        // actionSheet = this.actionSheetCtrl.create({
        //     title: 'What would you like to do today?',
        //     buttons: actionSheetButtons
        // });

        // actionSheet.present();

    }

    openPage(page, barber) {
        this.loading = true;
        this.getShop().then((shop) => {
            this.navCtrl.push(page, {
                barber: barber,
                shop: shop,
                services: barber.services,
                byStaff: true
            }, {animate: false}).then(() => {
                this.loading = false;
            });
        })
    }

    openServices(barber, guestUser) {
        if (!this.isBarberUnavailable(barber) && !this.isBarberQueueFull(barber)) {
            if (barber.todays_cancelled_bookings.length) {
                this.navCtrl.push(CancelledBookingsPage, {
                    barber: barber,
                    shop: this.shop,
                    fromLobby: true,
                    guestUser: guestUser
                })
            } else {
                this.navCtrl.push(ServicesPage, {
                    barber: barber,
                    shop: this.shop,
                    fromLobby: true,
                    guestUser: guestUser
                })
            }
        }
    }

    showBarber(barber) {
        if (!barber.current_active_team) return false;
        if (barber.holidays.holidayToday) return false;

        if (barber.current_active_team !== this.shop.id) return false;

        return true;
    }

    isCurrentlyActiveBarber(barber, i) {
      return this.staffService.isCurrentlyActiveStaff(this.shop.id, barber, i);
    }

    isBarberUnavailable(barber) {
      return this.staffService.isStaffUnavailable(this.shop.id, barber);
    }

    isBarberQueueFull(barber) {
      return this.staffService.isStaffQueueFull(barber, this.shop.id);
    }

    isBarberAvailableAndQueueFull(barber) {
      return this.staffService.isStaffAvailableAndQueueFull(barber, this.shop.id);
    }

    getQueueClass(barber, i) {
        if (this.isCurrentlyActiveBarber(barber, i)) return 'card-queue--highlight';
        if (this.isBarberAvailableAndQueueFull(barber)) return 'card-queue--full';
        if (this.isBarberQueueFull(barber)) return 'card-queue--full';
        if (this.isBarberUnavailable(barber)) return '';
        return '';
    }

    screenSaver() {
        this.source = interval(1000).pipe(
            takeWhile(() => {
                this.screenSaverTimer = this.screenSaverTimer - 1000;
                return true;
            })
        );

        this.subscribe = this.source
            .subscribe(() => {
                if (this.screenSaverTimer === 0 && this.displayScreenSaver === true) {
                  this.showScreenSaver();
                }
            });
    }

    showScreenSaver(){

      return this.getAppData().then(appData => {

        let modal = this.modalCtrl.create(LobbyScreensaverPage, {
          'appData' : appData
        }, {
          cssClass: 'lobby-screensaver full-screen',
        });

        modal.present().then(() => {
          this.displayScreenSaver = false;
        });

        modal.onDidDismiss(() => {
          this.resetTimer();
        });

      }).catch(error=>{
        console.log(error);
      });

    }

    refreshShop() {
        this.source = interval(30000).pipe(
            takeWhile(() => {
                if (!this.subscribe.closed) {
                    return true
                }
            })
        );

        this.subscribe = this.source
            .subscribe(() => {

                this.getShop().then((shop) => {
                    this.getHolidays(shop).then((shopWithHolidays) => {
                        this.shop = shopWithHolidays;
                    })
                })
            });
    }

    closeModal() {
        this.tabsProvider.show();
        this.viewCtrl.dismiss().then(() => {
            this.resetTimer();
        })
    }

    resetTimer() {
        this.screenSaverTimer = 60000;
        this.displayScreenSaver = true;
    }

    openingTime(hours, day) {
        if (hours && hours[day] !== null) {
            return this.formatTime(hours[day]) + ' - ' + this.formatTime(hours[`${day}_close`])
        }

        return 'Closed';
    }

    formatTime(time) {
        return moment(time, 'HH:mm:ss').format('h:mma');
    }

    ngOnDestroy() {
        this.subscribe.unsubscribe();
    }

    timeConvert(n) {
        var num = n;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return rhours < 0 ? rhours + " hr " + rminutes + " min" : rminutes + " min";
    }
}



// WEBPACK FOOTER //
// ./src/pages/lobby/lobby.ts